import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import HoldReasonForm from './HoldReasonForm';

const HoldReasonModal = ({ show, onHide, holdreasonvalue, edittrigger, onCallParent }) => {
    const isEdit = Boolean(
        holdreasonvalue && 
        (typeof holdreasonvalue === 'object' ? (holdreasonvalue.id || holdreasonvalue.reason_id || holdreasonvalue.holdreason_id) : (typeof holdreasonvalue === 'string' && holdreasonvalue.split(',')[2]))
    );

    const handleSuccess = () => {
        if (onCallParent) onCallParent();
        if (onHide) onHide();
    };

    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title as="h5">
                    {isEdit ? 'Edit Hold Reason' : 'Add Hold Reason'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-4">
                <HoldReasonForm
                    edittrigger={edittrigger}
                    onCallParent={handleSuccess}
                    holdreasonvalue={holdreasonvalue}
                />
            </Modal.Body>
        </Modal>
    );
};

HoldReasonModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    holdreasonvalue: PropTypes.any,
    edittrigger: PropTypes.number,
    onCallParent: PropTypes.func
};

export default HoldReasonModal;
